'use client';

import { FC, ReactNode } from 'react';

import { VisuallyHidden } from '@purpur/library';

type Props = {
    children: ReactNode;
};

export const VisuallyHiddenH1: FC<Props> = ({ children }) => (
    <VisuallyHidden>
        <h1>{children}</h1>
    </VisuallyHidden>
);
